import {getGroupProduct, getSalaryDeductionOccupationClassInfo} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as A from 'ApplicationEntry/ducks/ProductsRiders/accident';
import * as ANY from 'ApplicationEntry/ducks/ProductsRiders/accidentNewYork';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassInfoWarning,
} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';

function* getSalaryDeductionOccupationClass() {
  yield takeLatest(A.AccidentActionType.GET_OCC_CLASS, function*(action: ReturnType<typeof A.getOccClass>) {
    const {payload} = action;
    const {caseNumber, plan} = payload;
    const {life70Name} = plan;

    const response: AsyncResult<SalaryDeductionOccupationClassInfo> = yield call(
      getSalaryDeductionOccupationClassInfo,
      caseNumber,
      life70Name!
    );

    if (E.isRight(response)) {
      yield put(A.changeOccClass(new Loaded(response.right)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      if (
        response.left.key === 'NotFound' &&
        response.left.errorDetails!.messages.some(
          (m: {message: string; responseSeverity: string}) =>
            m.message === 'Description: Salary deduction information for the provided input was not found.'
        )
      ) {
        yield put(
          A.changeOccClass(
            new SalaryDeductionOccupationClassInfoWarning(
              'An occupation class that is based on the provided arguments could not be found.'
            )
          )
        );
      } else {
        yield put(A.changeOccClass(response.left));
      }
    }
  });
}

function* getPackageList() {
  yield takeLatest(A.AccidentActionType.GET_ACCIDENT_PACKAGES, function*(
    action: ReturnType<typeof A.getGroupAccidentPackages>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;
    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(A.changeGroupAccidentPackages(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(A.changeGroupAccidentPackages(response.left));
    }
  });
}

function* getGroupAccidentNYPackages() {
  yield takeLatest(ANY.AccidentNewYorkActionType.GET_GROUP_ACCIDENT_NEW_YORK_PACKAGES, function*(
    action: ReturnType<typeof ANY.getGroupAccidentNYPackages>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;
    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(ANY.changeGroupAccidentNYPackages(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(ANY.changeGroupAccidentNYPackages(response.left));
    }
  });
}

export default function*() {
  yield all([getSalaryDeductionOccupationClass(), getPackageList(), getGroupAccidentNYPackages()]);
}
